/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  AnimaticGaugeState,
  AnimaticGaugeState$inboundSchema,
  AnimaticGaugeState$Outbound,
  AnimaticGaugeState$outboundSchema,
} from "./animaticgaugestate.js";

/**
 * The kind of the gauge. This is used to determine the type of gauge.
 */
export const AnimaticGaugeKind = {
  Linear: "linear",
  LinearSetpoint: "linear_setpoint",
} as const;
/**
 * The kind of the gauge. This is used to determine the type of gauge.
 */
export type AnimaticGaugeKind = OpenEnum<typeof AnimaticGaugeKind>;

/**
 * Defines an animatic gauge that is overlaid on top of an animatic, its states, and how it should be configured for each state.
 */
export type AnimaticGauge = {
  /**
   * The kind of the gauge. This is used to determine the type of gauge.
   */
  kind: AnimaticGaugeKind;
  /**
   * The states of the gauge.
   */
  states: Array<AnimaticGaugeState>;
};

/** @internal */
export const AnimaticGaugeKind$inboundSchema: z.ZodType<
  AnimaticGaugeKind,
  z.ZodTypeDef,
  unknown
> = openEnums.inboundSchema(AnimaticGaugeKind);
/** @internal */
export const AnimaticGaugeKind$outboundSchema: z.ZodType<
  string,
  z.ZodTypeDef,
  AnimaticGaugeKind
> = openEnums.outboundSchema(AnimaticGaugeKind);

/** @internal */
export const AnimaticGauge$inboundSchema: z.ZodType<
  AnimaticGauge,
  z.ZodTypeDef,
  unknown
> = z.object({
  kind: AnimaticGaugeKind$inboundSchema,
  states: z.array(AnimaticGaugeState$inboundSchema),
});
/** @internal */
export type AnimaticGauge$Outbound = {
  kind: string;
  states: Array<AnimaticGaugeState$Outbound>;
};

/** @internal */
export const AnimaticGauge$outboundSchema: z.ZodType<
  AnimaticGauge$Outbound,
  z.ZodTypeDef,
  AnimaticGauge
> = z.object({
  kind: AnimaticGaugeKind$outboundSchema,
  states: z.array(AnimaticGaugeState$outboundSchema),
});

export function animaticGaugeToJSON(animaticGauge: AnimaticGauge): string {
  return JSON.stringify(AnimaticGauge$outboundSchema.parse(animaticGauge));
}
export function animaticGaugeFromJSON(
  jsonString: string,
): SafeParseResult<AnimaticGauge, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AnimaticGauge$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AnimaticGauge' from JSON`,
  );
}
